import socket from './socket';

const getContentViewPlans = (pointSystemId, headers) =>
  socket.get(`/point-systems/${pointSystemId}/content-view-plans`, undefined, headers);

const getOrCreateContentViewPlan = (pointSystemId, data, headers) =>
  socket.post(`/point-systems/${pointSystemId}/content-view-plans/get-or-create`, data, headers);

const updateContentViewPlan = (id, data, headers) => socket.patch(`/content-view-plans/${id}`, data, headers);

export default {
  getContentViewPlans,
  getOrCreateContentViewPlan,
  updateContentViewPlan,
};

